import { OutlinedTextFieldProps } from '@mui/material';
import { FieldProps } from 'formik';
import React, { useEffect, useState } from 'react';

import {
  TextAreaContainer,
  TextAreaLabelStyled,
  TextAreaSectionStyled,
  TextAreaStyled,
} from './TextArea.style';

export interface FormTextAreaProps extends FieldProps, OutlinedTextFieldProps {
  onChangeValidate?(
    name: string,
    e: React.ChangeEvent<HTMLTextAreaElement>
  ): void;
  onBlurValidate?(name: string, e: React.FocusEvent<HTMLTextAreaElement>): void;
  values: any;
}

export enum TextAreaStyleType {
  'default',
  'readOnly',
  'disabled',
  'contactFormModal',
  'contactFormPage',
  'workshop',
}

export interface Props extends FormTextAreaProps {
  semicontrolled?: boolean;
  showErrorOnlyIfTouched?: boolean;
  styleType?: TextAreaStyleType;
  Icon?: React.ReactElement;
  inline?: boolean;
  section: string;
  onChangeValue?(e: React.ChangeEvent<HTMLTextAreaElement>): void;
  onBlurValue?(e: React.ChangeEvent<HTMLTextAreaElement>): void;
}

const TextArea: React.FC<Props> = ({
  field,
  children,
  semicontrolled,
  onChangeValue,
  onBlurValue,
  styleType = TextAreaStyleType.default,
  inline = false,
  Icon,
  section,
  ...props
}) => {
  const [internalValue, setInternalValue] = useState('');
  const id = `${section}_${field.name}`;

  useEffect(() => {
    setInternalValue('');
  }, [field.name]);

  return (
    <TextAreaSectionStyled inline={inline}>
      {props.label && (
        <TextAreaLabelStyled
          styleType={styleType}
          withIcon={Icon ? true : false}
          htmlFor={id}
        >
          {Icon || null}
          {props.label}
        </TextAreaLabelStyled>
      )}
      <TextAreaContainer>
        <TextAreaStyled
          {...props}
          id={id}
          name={field.name}
          disabled={
            styleType === TextAreaStyleType.default ||
            styleType === TextAreaStyleType.readOnly
          }
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): void => {
            semicontrolled && setInternalValue(e.target.value);
            field.onChange(e);
            onChangeValue && onChangeValue(e);
          }}
          onClick={(): void => setInternalValue('')}
          onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>): void => {
            field.onBlur(e);
            onBlurValue && onBlurValue(e);
          }}
          styleType={styleType}
          value={semicontrolled ? internalValue || field.value : field.value}
        >
          {children}
        </TextAreaStyled>
      </TextAreaContainer>
    </TextAreaSectionStyled>
  );
};

export default TextArea;
